// store/reducers/productSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { developerTollApi } from "../../services/developerTollApi";
import Cookies from "js-cookie";
// const toPascalCase = (str) => str.replace(/(^\w|-\w)/g, (match) => match.replace('-', '').toLowerCase());
const toPascalCase = (str) =>
  str
    .replace(/\s+/g, "_")
    .replace(/(^\w|_\w)/g, (match) => match.replace("_", "").toUpperCase());

var token = Cookies.get("_d_token");
export const fetchTopProducts = createAsyncThunk(
  "products/fetchTopProducts",
  async (_, { getState, rejectWithValue }) => {
    try {
      let response;
      if (token) {
        response = await developerTollApi.getAllProducts();
      } else {
        response = await developerTollApi.getAllPublicProducts();
      }
      if (response?.status) {
        const currentPath = decodeURIComponent(window.location.pathname);
        const transformedItems = response.data.map((item) => {
          const iconKey = toPascalCase(item.product_name).toLowerCase();
          const isSelfActive = currentPath === `/products/${item.product_name}`;
          const getIconColor = () => {
            if (isSelfActive) return "#FFFFFF";
            if (currentPath.includes(`/products/${item.product_name}`))
              return "#185CB7";
            return "#1D1D1D";
          };

          return {
            title: item.product_name,
            path: `products/${item.product_name}`,
            id: item.product_id,
            iconKey,
            type: "product",
            iconColor: getIconColor(),
            has_child_items: item.has_child_items, //this key is newly added by me and rahul
          };
        });

        // 👇 return both transformed and raw items
        return {
          items: transformedItems,
          rawItems: response.data,
        };
      }
      return rejectWithValue("Failed to fetch");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchChildItems = createAsyncThunk(
  "products/fetchChildItems",
  async (item, { rejectWithValue }) => {
    try {
      let response;
      if (item.type === "product") {
        console.log(token);
        debugger;
        if (token || Cookies.get("_d_token")) {
          response = await developerTollApi.getAllTags(item.id);
        } else {
          response = await developerTollApi.getAllPublicProductTags(item.id);
        }
      } else if (item.type === "tag") {
        if (token || Cookies.get("_d_token")) {
          response = await developerTollApi.getAllTagEndpoint(item.id);
        } else {
          response = await developerTollApi.getAllPublicTagsEndpoint(item.id);
        }
      }

      if (response?.status) {
        const uid = `${item.type}-${item.id}`;
        const rawData = response.data;
        const data = rawData.map((child) => ({
          title: child.tag_name || child.endpoint_name,
          path: `${item.path}/${child.tag_name || child.endpoint_name}`,
          id: child.tag_id || child.endpoint_id,
          type: item.type === "product" ? "tag" : "endpoint",
        }));
        return { uid, data, rawItems: rawData };
      }
      return rejectWithValue("Failed to fetch children");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const productSlice = createSlice({
  name: "products",
  initialState: {
    items: [],
    rawItems: [],
    childrenMap: {},
    rawChildrenMap: {},
    openMap: {},
    loading: false,
    error: null,
  },
  reducers: {
    toggleOpen: (state, action) => {
      const uid = action.payload;
      const isCurrentlyOpen = state.openMap[uid];

      // If closing the current item, just close it
      if (isCurrentlyOpen) {
        state.openMap[uid] = false;
      } else {
        // Extract the type (product, tag, endpoint) from uid
        const [type] = uid.split("-");

        // Close all items of the same type
        Object.keys(state.openMap).forEach((key) => {
          if (key.startsWith(`${type}-`)) {
            state.openMap[key] = false;
          }
        });

        // Open the new item
        state.openMap[uid] = true;
      }
    },
    openOnly: (state, action) => {
      const uid = action.payload;
      state.openMap[uid] = true; // Only opens
    },
    expandPathByUIDs: (state, action) => {
      const uids = action.payload; // an array of UIDs like ['product-8', 'category-12']
      uids.forEach((uid) => {
        state.openMap[uid] = true;
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTopProducts.fulfilled, (state, action) => {
        state.items = action.payload.items;
        state.rawItems = action.payload.rawItems;
        state.loading = false;
      })
      .addCase(fetchTopProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchChildItems.fulfilled, (state, action) => {
        state.childrenMap[action.payload.uid] = action.payload.data;
        state.rawChildrenMap = {
          ...state.rawChildrenMap,
          [action.payload.uid]: action.payload.rawItems,
        };
      });
  },
});

export const { toggleOpen, openOnly, expandPathByUIDs } = productSlice.actions;
export default productSlice.reducer;
